import { render } from "./RegisterOwnerForm.vue?vue&type=template&id=5f5a5462"
import script from "./RegisterOwnerForm.vue?vue&type=script&lang=js"
export * from "./RegisterOwnerForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__